<template>
  <fin-data-loader :resolver="resolver" :params="documents" :data-adapter="adapter" class="my-6">
    <template #content="{data}">
      <v-alert v-if="alert"
               :color="$finColors.primaryDark"
               dark
               dense
               :icon="alert.icon"
               type="info">
        {{ alert.msg }} <br/>
        <fin-lexicon-link class="lexicon-link" to="bafin_regulation">Was sind das für Dokumente und warum muss ich sie
          bestätigen?
        </fin-lexicon-link>
      </v-alert>
      <fin-document-downloads :items="[data.gtb]" name="comment" v-if="data.gtb">
        <template #intro v-if="!noIntro">
          <p>
            Hier findest du unsere aktuellen AGBs zum Herunterladen und unsere Datenschutzerklärung:
          </p>
        </template>
        <template #more-infos>
          <ul v-if="!isIosOrAndroidApp">
            <li>
              <v-icon :color="$finColors.primaryDark"
                      class="mr-1"
                      small>mdi-open-in-new
              </v-icon>
              <router-link :to="{name: dataProtectionPage}"
                           :target="isIosOrAndroidApp || $route.name === 'myProfile' ? '_self' : '_blank'">
                Datenschutzerklärung
              </router-link>
            </li>
          </ul>
        </template>
      </fin-document-downloads>

      <fin-document-downloads class="mt-6" :items="data.bafinDocs" name="comment"
                              v-if="data.bafinDocs && data.bafinDocs.length">
        <template #intro v-if="!noIntro">
          <p>
            Hier findest du die regulatorischen Dokumente:
          </p>
        </template>
      </fin-document-downloads>

      <div>
        <div>
          <slot name="actions"/>
        </div>
      </div>
    </template>

  </fin-data-loader>
</template>

<script>
import FinDocumentDownloads from "@/components/common/DocumentDownloads"
import FinDataLoader from "@/components/common/DataLoader"
import finBrowser from "@/js/finBrowser"
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"

export default {
  name: 'FinRegulationDocumentDownloads',
  components: {FinLexiconLink, FinDataLoader, FinDocumentDownloads},
  props: {
    documents: {
      type: Array
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Object
    },
    protected: {
      type: Boolean
    },
    noIntro: {
      type: Boolean
    },
  },
  data() {
    return {
      isIosOrAndroidApp: finBrowser.IS_IOS_OR_ANDROID_APP
    }
  },
  computed: {
    dataProtectionPage() {
      return this.protected ? 'dataProtectionProtected' : 'finDataProtection'
    },
    redirect() {
      try {
        return this.$route.query.redirect
      } catch (e) {
        return undefined
      }
    }
  },
  methods: {
    async resolver(docs) {
      return await Promise.all(docs.map(async (doc) => {
        return {
          ...doc,
          url: await this.$Amplify.Storage.get(doc.fileName, {level: doc.isPrivate ? 'private' : 'public'})
        }
      }))
    },
    adapter: (data) => ({
      gtb: data.find(doc => doc.documentId === 'gtb'),
      bafinDocs: data.filter(doc => doc.documentId !== 'gtb')
    })
  }
}
</script>

<style lang="scss" scoped>
.lexicon-link {
  font-size: 14px;
}
</style>
